// extracted by mini-css-extract-plugin
export default {"exiting":"fade_exiting__AX3xe"};